import { request } from '../request'

type INonceResponse = {
  nonce: string,
  message: string
}

type IAuthLoginDto ={
  walletAddress: string
  signature: string
  nonce: string
}

type IAuthLoginResponse ={
  token: string
  authToken: string
  cometchatAuthToken: string
}

class UserAPI {

  async getNonceData (): Promise<INonceResponse> {
    try {
      const { data } = await request.get('/api/auth/nonce');
      return data
    } catch (err) {
      console.error('Fetch nonce data failed', err);
      throw err
    }
  }

  async authLogin (body: IAuthLoginDto): Promise<IAuthLoginResponse> {
    try {
      const { data } = await request.post<IAuthLoginResponse>('/api/auth/login', body, {
      });
      return data
    } catch (err) {
      console.error('Auth login failed', err);
      throw err
    }
  }

}

export const userAPI = new UserAPI
